/**
 * AIOコンテンツモード - TIPSデータ
 *
 * ユーザーの成功を導くための実践的なヒント集
 * カテゴリー別に整理し、各画面で適切なTIPSを表示
 */

// 【全般・基礎知識】ダッシュボードやスタート画面向け
export const generalTips = [
  'AIOコンテンツモードは「リサーチ→生成」の2ステップ構成です。キーワードのリサーチ結果を元に記事を生成します',
  'リサーチなしでも生成できますが、リサーチを活用すると競合分析データを踏まえた記事を作成できます',
  'スタイル機能で文体や記事の形式を設定できます。複数記事で統一感を出すのに便利です',
  '独自情報を登録して呼び出すことで、自社の情報を記事に織り込めます',
  '生成途中で離脱しても進捗は保存されます。ダッシュボードからいつでも再開できます',
  'お気に入りキーワードを登録しておくと、次回以降すぐにリサーチを開始できます',
];

// 【リサーチ】分析画面・新規リサーチ画面向け
export const researchTips = [
  'リサーチでは上位サイトを分析し、検索意図・トピック構造・コンテンツ戦略を明らかにします',
  'トピック分析で、競合がどの話題をどれだけ扱っているかが分かります',
  '競合の文字数・見出し数から、そのキーワードで求められるコンテンツボリュームの目安が分かります',
  'リサーチ結果は共有URLで他のメンバーと共有できます。パスワード保護も可能です',
  '検索難易度スコアで、そのキーワードの競合性を確認できます',
  'リサーチは画面を閉じても自動実行され、最短数分で完了します',
];

// 【生成STEP1】基本設定画面向け
export const generationStep1Tips = [
  'リサーチ結果を選択すると、分析結果を踏まえた構成案が生成されます',
  'スタイルで文体や記事の形式を設定することで、AIが一つの基準として意識しながら生成します',
  'STEP3の構成案編集時に独自情報を織り込むことができます',
];

// 【生成STEP2】構成案選択画面向け
export const generationStep2Tips = [
  'STEP2では3つの構成案が生成されます。見出しの構成や展開が異なるので、比較して選べます',
  '各構成案の推定文字数も表示されるので、大まかな記事のボリューム感を確認できます',
  '構成案の生成には5〜6分ほどかかります。結果が出るまでしばらくお待ちください',
];

// 【生成STEP3】構成編集画面向け
export const generationStep3Tips = [
  'STEP3では見出し構成を編集できます。H2・H3・H4の追加・削除・並び替えが可能です',
  'H3、H4はラベルをクリックすることで切り替えられます。デフォルトはH3です',
  '見出しはドラッグ&ドロップで並び替えられます',
  '構成は一定時間おきに自動保存されます。一旦離脱しても、ダッシュボードから再開できます',
  '各見出しにはメモを追加できます。これは生成時にもAIが参考にします',
  '独自情報はH2、H3、H4、セクション内パーツとしてそれぞれ織り込むことができます',
  '独自情報は見出しを編集できます。本文生成にも反映されるので重要です',
  'STEP3からSTEP2に戻ることができます。構成確定後（STEP4.1以降）は戻れません',
];

// 【生成STEP4-1】執筆計画画面向け
export const generationStep4_1Tips = [
  'STEP4-1では各見出しの執筆プランを作成します。各セクションで何をどう書くかの重要な設計図です',
  '執筆プランを元に、AIエージェントが膨大な調査をした上で記事を執筆します',
  '執筆プランの生成は通常1分以内で完了します',
  'STEP4.1からSTEP3に戻って構成を再編集することも可能です',
];

// 【生成STEP4-2】本文生成画面向け
export const generationStep4_2Tips = [
  'STEP4-2では記事本文が生成されます。見出しごとに順番に生成されます',
  '本文生成中は他の作業をしても問題ありません。バックグラウンドで処理が進みます',
  '生成された本文には参考にした情報元が付与されます',
  '各見出しの文字数は、スタイルや構成案、セクション内パーツや内容に応じて調整されます',
  '本文生成には5〜10分程度かかります。結果が出るまでしばらくお待ちください',
];

// 【生成STEP4-3】ブラッシュアップ画面向け
export const generationStep4_3Tips = [
  'STEP4-3ではAIが記事を推敲します。スタイル統一・記事一貫性・表記ルール・読みやすさの4つの項目から選べます',
  'ブラッシュアップは何度でも実行できます。バージョン管理されるので、過去の版に戻すこともできます',
  'カスタムプロンプトで独自の改善指示も出せます。具体的に指示すると効果的です',
  '初稿のままで問題ない場合はスキップできます',
  'スタイル統一性チェックは、文体や口調の揺れを検出して修正します',
  'ブラッシュアップはランクやプランによって一記事あたりの実行可能な回数が異なります。',
];

// 【生成STEP4-4】最終調整画面向け
export const generationStep4_4Tips = [
  'STEP4-4では記事を最終確認・編集できます。見出しや本文も直接編集できます',
  '編集内容はリアルタイムで自動保存されます',
  '「生成完了」をするとEXPを獲得でき、閲覧モードとして過去フローを振り返ることができます',
  '画像挿入機能で記事にビジュアルを追加できます。文章の説明にも使えます',
  '引用番号[1]をクリックすると出典情報を確認できます',
  '生成完了後は編集できなくなります。確定前にしっかり確認しましょう',
  'HTMLとしてコピーすると、WordPress等にそのまま貼付できます。',
  'Google Docs用にコピーすると、Googleドキュメント等にマークダウン形式で貼付できます',
];

// 【スタイル管理】スタイル設定画面向け
export const styleTips = [
  'スタイルで記事の文体や記事の形式を設定できます。ターゲット読者に合わせて調整しましょう',
  '「です・ます」比率を高めると丁寧な印象、低めるとカジュアルな印象になります',
  '接続詞の使用頻度も調整できます。多すぎると冗長、少なすぎると唐突に感じられることがあります',
  '登録したスタイルは微調整できます',
  '作成したスタイルは全記事で再利用できます',
];

// 【待機中・ローディング】長時間処理の待機画面向け
export const waitingTips = [
  '処理中は膨大なデータを分析しています。記事の長さによって時間が変動します',
  '生成中は他の記事を確認したり、次のキーワードを検討するのもおすすめです',
  '処理時間はキーワードの競合性や記事の長さによって変わります',
];

// デフォルトエクスポート（後方互換性のため）
const tipsData = [
  ...generalTips.slice(0, 3),
  ...generationStep2Tips.slice(0, 2),
  ...generationStep3Tips.slice(0, 3),
  ...styleTips.slice(0, 2),
];

export default tipsData;
